import { createGlobalStyle } from 'styled-components'
import { getSpacing, text, flex } from './mixing'

const globalStyle = createGlobalStyle`
  #root {
    white-space: pre-line;
  }

  .d-flex {
    display: flex;
  }

  .d-block {
    display: block;
  }

  .right-0 {
    right: 0;
  }

  .top-0 {
    top: 0;
  }

  .flex-0 {
    flex: 0;
  }

  .flex-1 {
    flex: 1;
  }

  .w-100 {
    width: 100%;
  }

  .w-75 {
    width: 75%;
  }

  .w-50 {
    width: 50%;
  }

  .w-25 {
    width: 25%;
  }

  .h-100 {
    height: 100%;
  }

  .min-h-100 {
    min-height: 100%;
  }

  .min-w-100 {
    min-width: 100%;
  }

  .max-w-100 {
    max-width: 100%;
  }

  .scroll-y {
    overflow-y: auto;
  }

  .scroll-x-hidden {
    overflow-x: hidden;
  }

  .flex-column {
    flex-direction: column;
  }

  .flex-column-reverse {
    flex-direction: column-reverse;
  }

  .flex-row {
    flex-direction: row;
  }

  .flex-row-reverse {
    flex-direction: row-reverse;
  }

  .flex-wrap {
    flex-wrap: wrap;
  }

  .z-99 {
    z-index: 99;
  }

  .p-relative {
    position: relative;
  }

  .p-absolute {
    position: absolute;
  }

  .word-break {
    word-break: break-all;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  ${getSpacing('margin', 'm')}
  ${getSpacing('padding', 'p')}

  .productCreationTour .description {
    font-size: 16px;
    line-height: 24px;
  }

  .productCreationTour ul {
    margin-top: 0;
    padding-left: 22px;
  }

  .productCreationTour .MaasProduct-MuiTourIntroState-textTitle-52 {
    margin-bottom: 24px;
  }

  .productCreationTour .MaasProduct-MuiTourIntroState-gridContent-43 {
    justify-content: unset;
  }

  .productCreationTour .MaasProduct-MuiTourIntroState-contentButton-50 {
    margin-top: auto;
  }

  ${text}
  ${flex}
`

export default globalStyle
